/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Channel_EmailInputs */

const tr_landing_pricerules_channel_email = /** @type {(inputs: Landing_Pricerules_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const en_landing_pricerules_channel_email = /** @type {(inputs: Landing_Pricerules_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_landing_pricerules_channel_email = /** @type {(inputs: Landing_Pricerules_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const ru_landing_pricerules_channel_email = /** @type {(inputs: Landing_Pricerules_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эл. почта`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Landing_Pricerules_Channel_EmailInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_channel_email = /** @type {((inputs?: Landing_Pricerules_Channel_EmailInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Channel_EmailInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_channel_email(inputs)
	if (locale === "de") return de_landing_pricerules_channel_email(inputs)
	if (locale === "ru") return ru_landing_pricerules_channel_email(inputs)
	return tr_landing_pricerules_channel_email(inputs)
});